import moment from 'moment';
import getOffsetTime from '../../../../../utils/getOffsetTime';


const addTour = (itemDetails, dayTypesAllowTour) => {
  const { dayTypeId, tourStartTime, tourEndTime, mealStartTime, mealEndTime } = itemDetails;
  const { notification, comment, comment15  } = itemDetails.tourParams;
  const tempDayTypeId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;
  const tempTourId = `${Math.floor(Math.random() * (19999999 - 10000000 + 1)) + 10000000}-optimistic`;
  const tempMealId = `${Math.floor(Math.random() * (9999999 - 9000000 + 1)) + 9000000}-optimistic`;

  let timeZoneOffset = getOffsetTime(tourStartTime._d);
  let startTime = moment(tourStartTime).clone();
  startTime = startTime.subtract(timeZoneOffset, 'minutes').unix();
  let mealStartTimeUnix = moment(mealStartTime).clone();
  mealStartTimeUnix = mealStartTimeUnix.subtract(timeZoneOffset, 'minutes').unix();
  let mealEndTimeUnix = moment(mealEndTime).clone();
  mealEndTimeUnix = mealEndTimeUnix.subtract(timeZoneOffset , 'minutes').unix();
  // create new dayType, tour and meal
  const tour = {
    tourId: tempTourId,
    startTime,
    duration: moment.duration(tourEndTime.diff(tourStartTime)).asHours(),
    notificationComment: notification,
    tourComment: comment,
    myTourComment: comment15,
    tourIndicators: [],
    tourPayTransactions: [],
    meal: mealStartTime ? {
      mealId: tempMealId,
      mealTime: mealStartTimeUnix,
      mealEndTime: mealEndTimeUnix,
      red: false
    } : null,
    assignments: {}
  };
  const dayType = {
    rdtId: tempDayTypeId,
    title: dayTypesAllowTour.find((elem) => elem.id == dayTypeId).name,
    rdtComment: itemDetails.dayTypeParams ? itemDetails.dayTypeParams.comment : " ",
    myDayComment: itemDetails.dayTypeParams ? itemDetails.dayTypeParams.myComment : " ",
    dayOff: null,
    tour
  };
  return dayType;
}

export default addTour;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/generateNewOptimisticItems/addTour.js